import { logoutApi } from "@/api/services/admin/auth";
import { AppRoutes } from "@/routes/config";
import { logout } from "@/utils/api";
import { useEffect } from "react";

const Logout = () => {
  useEffect(() => {
    const handleLogout = async () => {
      await logoutApi();
      logout();
      window.location.replace(AppRoutes.login);
    };

    handleLogout();
  }, []);

  return null;
};

export default Logout;
